import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext.tsx';
import { useTenant } from '../contexts/TenantContext.tsx';
import { formatMoney, pluralize } from '../lib/format.ts';

interface CartBarProps {
  slug: string;
  accentColor: string;
}

export function CartBar({ slug, accentColor }: CartBarProps) {
  const { count, subtotal } = useCart();
  const { snapshot } = useTenant();
  const navigate = useNavigate();

  if (count === 0) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-30 p-3"
      style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}
    >
      <button
        onClick={() => navigate(`/s/${slug}/cart`)}
        className="flex w-full items-center justify-between rounded-2xl px-5 py-3.5 shadow-lg"
        style={{ background: accentColor, color: '#fff' }}
        aria-label={`Корзина, ${pluralize(count, ['позиция', 'позиции', 'позиций'])}`}
      >
        <span
          className="flex h-7 w-7 items-center justify-center rounded-full text-sm font-bold"
          style={{ background: 'oklch(100% 0 0 / 0.25)' }}
        >
          {count}
        </span>
        <span className="text-base font-semibold">Корзина</span>
        <span className="text-base font-semibold tabular-nums">
          {formatMoney(subtotal, snapshot.tenant.currency)}
        </span>
      </button>
    </div>
  );
}
